/* eslint-disable import/prefer-default-export */
export const getSubdomain = () => {
  const { hostname } = window.location;
  const parts = hostname.split(".");
  return parts.length > 2 ? parts[0] : "";
};
